import { defineMessages } from 'react-intl';

export default defineMessages({
  sellerComment: {
    id: 'components.myaccount.myReturn.details.sellerComment',
    defaultMessage: 'Seller comment',
  },
});
